import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Space, Table} from "antd";
import api from "../../services/api";

const Options = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        (async () => {
            const groups = await api.groups();

            setData(groups.data);
        })()
    }, [])

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Action',
            key: 'action',
            render: (_: any, record: any) => (
                <Space size="middle">
                    <a onClick={() => onDelete(record)}>Delete</a>
                </Space>
            ),
        },
    ]

    const onDelete = async (record: any) => {
        await api.deleteGroup(record.name);

        window.location.reload()
    }

    const onCreate = async ({ name }: any) => {
        await api.createGroup(name);

        window.location.reload()
    }

    return (
        <div style={{ height: '100vh', width: '100vw', justifyContent: 'center', display: 'flex', overflow: 'hidden' }}>
            <div style={{ width: '80vw', marginTop: '15px' }}>
                <div style={{ width: '300px'}}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={onCreate}
                        autoComplete="off"
                    >

                        <Form.Item
                            label="Group Name"
                            name="name"
                            rules={[{ required: true, message: 'Please input group name!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" htmlType="submit">
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </div>

                <Table columns={columns} dataSource={data} />
            </div>
        </div>
    );
};

export default Options;